import React, { useState } from 'react';
import './Products_page.css';
import { FiEdit2 } from 'react-icons/fi';
import Navigation from '../../Components/Navigation';
import { BiChart } from 'react-icons/bi';
import { FaUserTie, FaRocket } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Products_page = () => {
  const navigate = useNavigate();
  const [products] = useState([
    { 
      id: 1, 
      name: 'Basic Plan',
      icon: <BiChart className="plan-icon" />,
      description: 'Perfect for beginners starting their investment journey',
      price: '₹999',
      category: 'Basic',
      features: [
        'Basic Stock Research',
        'Daily Market Updates',
        'Email Support',
        'Basic Portfolio Tracking',
        'Weekly Newsletter'
      ]
    },
    { 
      id: 2, 
      name: 'Professional Plan',
      icon: <FaUserTie className="plan-icon" />,
      description: 'Ideal for active traders and serious investors',
      price: '₹2,999',
      category: 'Professional',
      features: [
        'Advanced Stock Research',
        'Real-time Market Alerts',
        'Priority Email & Phone Support',
        'Advanced Portfolio Analytics',
        'Daily Research Reports',
        'Trading Strategies'
      ]
    },
    { 
      id: 3, 
      name: 'Premium Plan',
      icon: <FaRocket className="plan-icon" />,
      description: 'For professional traders and institutional clients',
      price: '₹4,999',
      category: 'Premium',
      features: [
        'Premium Stock Research',
        'Instant Market Alerts',
        '24/7 Priority Support',
        'Custom Portfolio Solutions',
        'Exclusive Research Reports',
        'Advanced Trading Strategies',
        'Personal Investment Advisor'
      ]
    }
  ]);

  const handleEdit = (productId) => {
    navigate(`/edit-product/${productId}`);
  };

  const handleAddNew = () => {
    navigate('/edit-product/new');
  };

  return (
    <div className="page-container">
      <Navigation />
      <div className="products-container">
        <div className="products-header">
          <h1 className="products-title">Subscription Plans</h1>
          <div className="products-actions">
            <button className="add-product-btn" onClick={handleAddNew}>Add New Plan</button>
          </div>
        </div>
        
        <div className="products-grid">
          {products.map((product) => (
            <div key={product.id} className="product-card">
              <div className="product-badge">{product.category}</div>
              <div className="product-content">
                <div className="product-icon">{product.icon}</div>
                <h3 className="product-name">{product.name}</h3>
                <p className="product-description">{product.description}</p>
                <div className="product-price">{product.price}</div>
                <ul className="features-list">
                  {product.features.map((feature, index) => (
                    <li key={index} className="feature-item">
                      <span className="feature-check">✓</span>
                      {feature}
                    </li>
                  ))}
                </ul>
              </div>
              <div className="product-actions">
                <button 
                  className="edit-button"
                  onClick={() => handleEdit(product.id)}
                >
                  <FiEdit2 className="edit-icon" />
                  Edit
                </button>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Products_page;
